import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import get from 'lodash/get';
import { miniPDPOnShopTheLookOpen } from 'yoda-site-components/lib/actions/MiniPDPAction';
import {
    shopTheLookLoadSuccess,
    shopThisLookClickEvent,
    shopTheLookMiniPDPClickEvent,
} from '../../../actions/AnalyticsAction';

let _onOutfitsLoaded = null;
let _onItemClick = null;
let _onLookClick = null;
let _lastClickPosition = 0;

const shopTheLookConfig = {
    id: 'shop-the-look',
    containerId: 'shopLookContainer',
    title: 'Shop The Look',
    titleId: 'widget-title',
    featureFlagKey: 'enableShopTheLook',
    imageQuery: '.stylitics-ui-image',

    getScriptURL: (prefs) => get(prefs, 'styliticsWidget.scriptURL', ''),

    createWidget: async (itemNumber) => {
        if (typeof StyliticsComposer === 'undefined') {
            throw new Error('StyliticsComposer is not available');
        }
        return StyliticsComposer.initialize({
            client: 'jcpenney',
            target: 'shopLookContainer',
            config: {
                modules: [
                    {
                        type: 'dimension-collage',
                        params: {
                            api: { min: 3, max: 6, item_number: itemNumber },
                            display: { enableDimensionUI: true },
                            text: {
                                viewDetailsCTA: 'Shop The Look',
                                itemLinkCTA: 'Shop',
                            },
                        },
                        on: {
                            'mount.outfits': ({ outfits }) => {
                                _onOutfitsLoaded?.(outfits);
                            },
                            'mount.item': ({ item, element }) => {
                                applyPromoOverride(element, item);
                            },
                            'click.outfit': (data) => {
                                const outfit = data?.outfit || data;
                                _onLookClick?.(outfit);
                            },
                        },
                        override: {
                            'click.item': (data) => {
                                const item = data?.item;
                                const outfit = data?.outfit;
                                const position = (outfit?.items || []).findIndex(
                                    (i) => i.item_id === item?.item_id
                                );
                                _lastClickPosition = position >= 0 ? position : 0;
                                _onItemClick?.(item, outfit);
                            },
                        },
                    },
                ],
            },
        });
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
    },

    registerLookClick: (callback) => {
        _onLookClick = callback;
    },

    refresh: (instance, itemNumber) => {
        instance?.refresh?.({ sharedParams: { api: { item_number: itemNumber } } });
    },

    analyticsLoadAction: shopTheLookLoadSuccess,
    analyticsClickAction: ({ id, ppId }) =>
        shopTheLookMiniPDPClickEvent({
            moduleName: 'shop the look',
            shopTheLookID: id?.toString() || '',
            shopTheLookPPID: ppId,
            linkText: 'Shop',
            linkPosition: _lastClickPosition,
        }),
    analyticsLookClickAction: ({ id, position }) =>
        shopThisLookClickEvent({
            moduleName: 'shop the look',
            shopTheLookID: id?.toString() || '',
            linkText: 'Shop The Look',
            linkPosition: position ?? 0,
        }),
    miniPDPAction: miniPDPOnShopTheLookOpen,
    analyticsModule: 'shop the look',
};

export default shopTheLookConfig;
